import { cssResult } from '../util/css.js';
import styles from './shared.scss.js';

const sharedStyles = cssResult(styles);

export { sharedStyles };
